import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import LoadingOverlay from "react-loading-overlay";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import PayCard from "../layout/PayCard";
import ENUMS from "../../utils/ENUMS";
import { BASE_URL } from "../../config.json";

const ClubPay = () => {
  const location = useLocation();

  // State management
  const [spinner, setSpinner] = useState(false);
  const [renewSubData, setRenewSubData] = useState(null);

  // Helper function to toggle spinner
  const changeSpinner = (value) => {
    setSpinner(value);
  };

  // API call to fetch renewal data
  const getRenewClubData = async () => {
    try {
      setSpinner(true);
      const token = localStorage.getItem(ENUMS.AUTH);
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await axios.get(
        `${BASE_URL}/club/courses_and_subscrption`,
        config
      );
      const data = response.data.data;

      setRenewSubData(data);
      storeBillingAddressInLocalStorage(data.billing_address);
    } catch (error) {
      console.error("Error fetching renewal data:", error);
    } finally {
      setSpinner(false);
    }
  };

  // Store billing address in localStorage
  const storeBillingAddressInLocalStorage = (address) => {
    localStorage.setItem("Renew-BillingAddress", JSON.stringify(address));
  };

  // Effects
  useEffect(() => {
    if (!location.state) {
      getRenewClubData();
    }
  }, [location.state]);

  useEffect(() => {
    spinner
      ? disableBodyScroll(document.body)
      : enableBodyScroll(document.body);
  }, [spinner]);

  // Render payment steps bar
  const renderStepsBar = () => (
    <div className="progress_bar">
      <ul className="progress_bar__row">
        <li className="text-jost-sb-22 completed">CLUB Details</li>
        <li className="text-jost-sb-22 completed">Golf Courses</li>
        <li className="text-jost-sb-22 active">Payment DETAILS</li>
        <li className="text-jost-sb-22">Confirmation</li>
      </ul>
    </div>
  );

  return (
    <section className="section-p club_Login">
      <div className="page-width">
        <LoadingOverlay
          active={spinner}
          spinner
          text={
            location.state
              ? "Processing payment..."
              : "Loading your club data..."
          }
        >
          <div className="cpay_block">
            <h1 className="text-jost-sb-50">
              Renew Your Subscription Today
            </h1>
            <div className="cpay__wrap-block">
              {renderStepsBar()}
              {location.state ? (
                <PayCard changeSpinner={changeSpinner} Data={location.state} />
              ) : (
                renewSubData && (
                  <PayCard
                    changeSpinner={changeSpinner}
                    Data={{ users: renewSubData.golf_courses }}
                    renewPay={true}
                  />
                )
              )}
            </div>
          </div>
        </LoadingOverlay>
      </div>
    </section>
  );
};

export default ClubPay;
